/**
 * Подраздел «Экология» → «Абонентское обслуживание» клиента-компании (`/ecology/subscription`,
 * ecology-subscription, макет варианта Б 17.09.2026): у абонента — блок «Сопровождение» с планом
 * работ, у остальных — предложение тарифов и заявка менеджеру (заказ услуги «Абонентское
 * обслуживание» на общих правилах раздела).
 */
import { ecologyClientApi } from '@/lib/api'
import { ECO_SUBSCRIPTION_CODE } from '@/lib/ecology'
import { useEcoData } from '@/ecology/use-eco-data'
import { useStartEcoOrder } from '@/ecology/order/start-order'
import { EcoSubscriptionCard, EcoSubscriptionOffer } from '@/ecology/subscription/panel'
import { PageHead } from '@/design-system/components/layout/page-head'
import { Panel } from '@/design-system/components/layout/panel'
import { Alert } from '@/design-system/components/feedback/alert'

export function EcologySubscriptionPage() {
  const { overview, catalog, loading, error } = useEcoData(ecologyClientApi)
  const order = useStartEcoOrder()
  const offerItem = catalog.find((c) => c.code === ECO_SUBSCRIPTION_CODE && c.showInOrder)

  return (
    <div>
      <PageHead
        title="Абонентское обслуживание"
        subtitle="Инженер-эколог Центрики ведёт экологию предприятия вместо штатного эколога"
      />
      {error ? (
        <Alert variant="danger">{error}</Alert>
      ) : loading || !overview ? (
        <Panel>
          <p className="px-4 py-10 text-center text-txt-secondary">Загрузка…</p>
        </Panel>
      ) : overview.subscription ? (
        <EcoSubscriptionCard subscription={overview.subscription} />
      ) : (
        <>
          {order.error ? (
            <Alert variant="danger" className="mb-4">
              {order.error}
            </Alert>
          ) : null}
          <EcoSubscriptionOffer
            requesting={order.starting}
            onRequest={
              offerItem ? () => order.start({ catalogItemId: offerItem.id }) : undefined
            }
          />
        </>
      )}
    </div>
  )
}
